// prettier-ignore
export default {
    js:     'JavaScript',
    mjs:    'JavaScript',

    ts:     'TypeScript',
    wasm:   'WebAssembly',
    map:    'Source Maps',
    swf:    'Flash',
    json:   'JSON',

    css:    'Styling',
    scss:   'Styling',

    png:    'Images',
    gif:    'Images',
    jpg:    'Images',
    jpeg:   'Images',
    svg:    'Images',
    webp:   'Images',
    cur:    'Images',

    ttf:    'Fonts',
    eot:    'Fonts',
    woff:   'Fonts',
    woff2:  'Fonts',
    otf:    'Fonts',

    aac:    'Audio',
    mp3:    'Audio',
    ogg:    'Audio',

    lang:   'Other',
    hpb:    'Other',
};
